import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Departamento, Empregador, Funcionario, PreviewAcertoPonto, RegistroPontoAlteracao } from '../../api.service';
import { ServicoBuscaCadastro } from '../../shared/servico-busca-cadastro';
import { ServicoMensagemAplicacao } from '../../shared/servico-mensagem-aplicacao';
import { GradeFolhaPontoComponent } from './grade-folha-ponto.component';
import { ModalAcertoPontoComponent } from './modal-acerto-ponto.component';
import { ModalHistoricoFolhaComponent } from './modal-historico-folha.component';
import { ModalFuncionarioExportacaoComponent } from './modal-funcionario-exportacao.component';
import { PainelFiltrosExportacaoComponent } from './painel-filtros-exportacao.component';
import { ServicoAcertoPonto } from './servico-acerto-ponto';
import { EstadoFiltroExportacao, EstadoFuncionarioFiltroExportacao, FormatoExportacao, LinhaExportacaoPonto, ServicoExportacaoPonto } from './servico-exportacao-ponto';
import { ServicoFiltroDepartamento } from '../../shared/servico-filtro-departamento';

@Component({
  selector: 'app-tela-exportacao',
  standalone: true,
  imports: [
    CommonModule,
    GradeFolhaPontoComponent,
    ModalAcertoPontoComponent,
    ModalHistoricoFolhaComponent,
    ModalFuncionarioExportacaoComponent,
    PainelFiltrosExportacaoComponent
  ],
  templateUrl: './tela-exportacao.component.html'
})
export class TelaExportacaoComponent implements OnChanges {
  @Input() empregadores: Empregador[] = [];
  @Input() empregadorSelecionado = '';
  @Input() funcionarios: Funcionario[] = [];
  @Input() departamentos: Departamento[] = [];

  @Output() empregadorSelecionadoChange = new EventEmitter<string>();
  @Output() mensagem = new EventEmitter<string>();

  funcionarioSelecionado = '';
  departamentoSelecionado: string[] = [];
  buscaFuncionario = '';
  buscaFuncionarioModal = '';
  dataInicial = this.servicoExportacaoPonto.filtroPadrao().dataInicial;
  dataFinal = this.servicoExportacaoPonto.filtroPadrao().dataFinal;
  formato: FormatoExportacao = 'csv';
  linhas: LinhaExportacaoPonto[] = [];
  linhaEditando = '';
  batidasEdicao: string[] = ['', '', '', ''];
  modalFuncionariosAberta = false;
  modalAcertoAberta = false;
  previewAcerto: PreviewAcertoPonto | null = null;
  carregandoAcerto = false;
  confirmandoAcerto = false;
  historicoAberto = false;
  historicoCarregando = false;
  historicoTitulo = 'Historico da folha';
  historicoErro = '';
  historicoAlteracoes: RegistroPontoAlteracao[] = [];
  private funcionarioAcerto?: string;
  private folhaPesquisada = false;

  constructor(
    private readonly servicoExportacaoPonto: ServicoExportacaoPonto,
    private readonly servicoBuscaCadastro: ServicoBuscaCadastro,
    private readonly servicoMensagemAplicacao: ServicoMensagemAplicacao,
    private readonly servicoAcertoPonto: ServicoAcertoPonto,
    private readonly servicoFiltroDepartamento: ServicoFiltroDepartamento
  ) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['empregadorSelecionado'] && !changes['empregadorSelecionado'].firstChange) {
      this.limpar();
    }

    if (this.funcionarioSelecionado && !this.funcionarios.some(item => item.id === this.funcionarioSelecionado)) {
      this.aplicarEstadoFuncionario(this.servicoExportacaoPonto.estadoFuncionarioLimpo());
      this.limparResultado();
    }
  }

  alterarBuscaFuncionario(valor: string) {
    this.buscaFuncionario = valor;
    if (this.funcionarioSelecionado && !this.buscaConfereFuncionarioSelecionado()) {
      this.funcionarioSelecionado = '';
      this.limparResultado();
    }

    if (!valor.trim()) {
      this.limpar();
      return;
    }
    if (valor.trim().length < 3) {
      this.funcionarioSelecionado = '';
      this.limparResultado();
      return;
    }

    if (this.funcionariosFiltrados.length === 1) {
      this.selecionarFuncionario(this.funcionariosFiltrados[0], false);
    }
  }

  get funcionariosFiltrados() {
    return this.servicoBuscaCadastro.filtrarFuncionarios(
      this.funcionariosPorDepartamento,
      this.buscaFuncionario,
      this.funcionarioSelecionado
    );
  }

  get funcionariosPorDepartamento() {
    return this.servicoFiltroDepartamento.funcionariosNoRecorte(
      this.funcionarios,
      this.departamentoSelecionado,
      this.departamentos
    );
  }

  get departamentoIdsConsulta() {
    return this.servicoFiltroDepartamento.consulta(this.departamentoSelecionado, this.departamentos.length);
  }

  get funcionariosModal() {
    return this.servicoBuscaCadastro.listarFuncionariosModal(this.funcionariosPorDepartamento, this.buscaFuncionarioModal);
  }

  rotuloFuncionario = (item: unknown) => this.servicoBuscaCadastro.rotuloFuncionario(item);

  detalheFuncionario = (item: unknown) => this.servicoBuscaCadastro.detalheFuncionario(item);

  abrirModalFuncionarios() {
    this.buscaFuncionarioModal = '';
    this.modalFuncionariosAberta = true;
  }

  fecharModalFuncionarios() {
    this.modalFuncionariosAberta = false;
  }

  limparBuscaFuncionarioModal() {
    this.buscaFuncionarioModal = '';
  }

  selecionarFuncionario(item: unknown, fecharModal = true) {
    const funcionario = item as Funcionario;
    this.aplicarEstadoFuncionario(
      this.servicoExportacaoPonto.estadoFuncionarioSelecionado(funcionario, this.rotuloFuncionario(funcionario))
    );
    this.limparResultado();
    if (fecharModal) {
      this.fecharModalFuncionarios();
    }
  }

  alterarDepartamento(departamentoIds: string[]) {
    this.departamentoSelecionado = departamentoIds;
    if (this.funcionarioSelecionado && !this.funcionariosPorDepartamento.some(item => item.id === this.funcionarioSelecionado)) {
      this.aplicarEstadoFuncionario(this.servicoExportacaoPonto.estadoFuncionarioLimpo());
    }
    this.limparResultado();
  }

  pesquisar() {
    if (!this.funcionarioSelecionado) {
      this.mensagem.emit(this.servicoExportacaoPonto.mensagemFuncionarioObrigatorioPesquisa());
      return;
    }
    this.carregarRegistros();
  }

  abrirAcertoServidor() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoAcertoPonto.mensagemEmpregadorObrigatorio());
      return;
    }
    if (!this.funcionarioSelecionado) {
      this.mensagem.emit(this.servicoAcertoPonto.mensagemServidorObrigatorio());
      return;
    }
    this.carregarPreviewAcerto(this.funcionarioSelecionado);
  }

  abrirAcertoGeral() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoAcertoPonto.mensagemEmpregadorObrigatorio());
      return;
    }
    this.carregarPreviewAcerto();
  }

  fecharAcerto() {
    this.modalAcertoAberta = false;
    this.carregandoAcerto = false;
    this.confirmandoAcerto = false;
  }

  confirmarAcerto(eventoIds: string[]) {
    if (!eventoIds.length) {
      this.mensagem.emit(this.servicoAcertoPonto.mensagemSelecaoObrigatoria());
      return;
    }
    this.confirmandoAcerto = true;
    this.servicoAcertoPonto.aplicar(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      eventoIds,
      this.funcionarioAcerto,
      this.departamentoIdsConsulta
    ).subscribe({
      next: resultado => {
        this.confirmandoAcerto = false;
        this.previewAcerto = resultado.preview;
        this.mensagem.emit(this.servicoAcertoPonto.resumoAplicacao(resultado));
        if (this.folhaPesquisada) {
          this.carregarRegistros();
        }
      },
      error: erro => {
        this.confirmandoAcerto = false;
        this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, this.servicoAcertoPonto.mensagemErroAplicar()));
      }
    });
  }

  limpar() {
    this.aplicarEstadoFiltro(this.servicoExportacaoPonto.estadoFiltroLimpo());
    this.limparResultado();
  }

  gerar() {
    if (!this.empregadorSelecionado) {
      this.mensagem.emit(this.servicoExportacaoPonto.mensagemEmpregadorObrigatorioExportacao());
      return;
    }
    if (this.formato === 'pdf') {
      this.gerarFolhaPontoPdf();
      return;
    }

    this.servicoExportacaoPonto.baixarArquivoPonto(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      this.servicoExportacaoPonto.formatoArquivoPonto(this.formato),
      this.funcionarioSelecionado || undefined,
      this.departamentoIdsConsulta
    ).subscribe({
      next: blob => this.finalizarDownload(
        blob,
        this.servicoExportacaoPonto.nomeArquivoPonto(this.dataInicial, this.dataFinal, this.formato),
        this.servicoExportacaoPonto.mensagemArquivoGerado()
      ),
      error: () => this.mensagem.emit(this.servicoExportacaoPonto.mensagemErroExportarArquivo())
    });
  }

  editarOuSalvarLinha(linha: LinhaExportacaoPonto) {
    if (this.servicoExportacaoPonto.deveEntrarEmEdicao(this.linhaEditando, linha)) {
      const edicao = this.servicoExportacaoPonto.iniciarEdicao(linha);
      this.linhaEditando = edicao.linhaEditando;
      this.batidasEdicao = edicao.batidasEdicao;
      return;
    }

    this.servicoExportacaoPonto.ajustarFolhaDia(linha.funcionarioId, linha.dataIso, this.batidasEdicao).subscribe({
      next: () => {
        this.mensagem.emit(this.servicoExportacaoPonto.mensagemFolhaAjustada());
        this.cancelarEdicaoLinha();
        this.carregarRegistros();
      },
      error: erro => this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao ajustar folha de ponto.'))
    });
  }

  cancelarEdicaoLinha() {
    const edicao = this.servicoExportacaoPonto.cancelarEdicao();
    this.linhaEditando = edicao.linhaEditando;
    this.batidasEdicao = edicao.batidasEdicao;
  }

  abrirHistorico(linha: LinhaExportacaoPonto) {
    if (!this.empregadorSelecionado || !linha.funcionarioId || !linha.dataIso) {
      return;
    }
    this.historicoAberto = true;
    this.historicoCarregando = true;
    this.historicoErro = '';
    this.historicoAlteracoes = [];
    this.historicoTitulo = `Historico de ${linha.matricula} - ${linha.nome} em ${linha.data}`;
    this.servicoExportacaoPonto.listarAlteracoesFolha(
      this.empregadorSelecionado,
      linha.funcionarioId,
      linha.dataIso
    ).subscribe({
      next: alteracoes => {
        this.historicoAlteracoes = alteracoes;
        this.historicoCarregando = false;
      },
      error: () => {
        this.historicoCarregando = false;
        this.historicoErro = this.servicoExportacaoPonto.mensagemErroHistoricoFolha();
      }
    });
  }

  fecharHistorico() {
    this.historicoAberto = false;
    this.historicoCarregando = false;
    this.historicoErro = '';
    this.historicoAlteracoes = [];
  }

  private carregarRegistros() {
    if (!this.empregadorSelecionado) {
      this.limparResultado();
      return;
    }

    this.cancelarEdicaoLinha();
    this.servicoExportacaoPonto.pesquisarFolhaPonto(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      this.funcionariosPorDepartamento,
      this.funcionarioSelecionado,
      this.departamentoIdsConsulta
    ).subscribe({
      next: resultado => {
        this.folhaPesquisada = true;
        this.linhaEditando = resultado.linhaEditando;
        this.linhas = resultado.linhas;
      },
      error: () => this.mensagem.emit(this.servicoExportacaoPonto.mensagemErroCarregarRegistros())
    });
  }

  private gerarFolhaPontoPdf() {
    const abaPdf = window.open('', '_blank');
    if (!abaPdf) {
      this.mensagem.emit(this.servicoExportacaoPonto.mensagemErroAbrirPdf());
      return;
    }

    this.servicoExportacaoPonto.baixarFolhaPdf(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      this.funcionarioSelecionadoValidoParaFiltro(),
      this.departamentoIdsConsulta
    ).subscribe({
      next: blob => {
        this.servicoExportacaoPonto.abrirPdfEmNovaAba(blob, abaPdf);
        this.mensagem.emit(this.servicoExportacaoPonto.mensagemFolhaPdfGerada());
      },
      error: erro => {
        abaPdf.close();
        this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, 'Erro ao gerar folha de ponto em PDF.'));
      }
    });
  }

  private finalizarDownload(blob: Blob, nomeArquivo: string, mensagemSucesso: string) {
    this.servicoExportacaoPonto.baixarBlob(blob, nomeArquivo);
    this.mensagem.emit(mensagemSucesso);
  }

  limparResultado() {
    const resultadoVazio = this.servicoExportacaoPonto.resultadoVazio();
    this.folhaPesquisada = false;
    this.linhaEditando = resultadoVazio.linhaEditando;
    this.linhas = resultadoVazio.linhas;
  }

  private aplicarEstadoFiltro(estado: EstadoFiltroExportacao) {
    this.funcionarioSelecionado = estado.funcionarioSelecionado;
    this.buscaFuncionario = estado.buscaFuncionario;
    this.buscaFuncionarioModal = estado.buscaFuncionarioModal;
    this.dataInicial = estado.dataInicial;
    this.dataFinal = estado.dataFinal;
    this.formato = estado.formato;
    this.departamentoSelecionado = estado.departamentoSelecionado;
  }

  private aplicarEstadoFuncionario(estado: EstadoFuncionarioFiltroExportacao) {
    this.funcionarioSelecionado = estado.funcionarioSelecionado;
    this.buscaFuncionario = estado.buscaFuncionario;
    this.buscaFuncionarioModal = estado.buscaFuncionarioModal;
  }

  private funcionarioSelecionadoValidoParaFiltro() {
    return this.buscaConfereFuncionarioSelecionado() ? this.funcionarioSelecionado : undefined;
  }

  private carregarPreviewAcerto(funcionarioId?: string) {
    this.funcionarioAcerto = funcionarioId;
    this.modalAcertoAberta = true;
    this.carregandoAcerto = true;
    this.confirmandoAcerto = false;
    this.previewAcerto = null;
    this.servicoAcertoPonto.preview(
      this.empregadorSelecionado,
      this.dataInicial,
      this.dataFinal,
      funcionarioId,
      this.departamentoIdsConsulta
    ).subscribe({
      next: preview => {
        this.previewAcerto = preview;
        this.carregandoAcerto = false;
        this.mensagem.emit(this.servicoAcertoPonto.resumo(preview));
      },
      error: erro => {
        this.carregandoAcerto = false;
        this.mensagem.emit(this.servicoMensagemAplicacao.erroApi(erro, this.servicoAcertoPonto.mensagemErroPreview()));
      }
    });
  }

  private buscaConfereFuncionarioSelecionado() {
    if (!this.funcionarioSelecionado) {
      return false;
    }
    const funcionario = this.funcionarios.find(item => item.id === this.funcionarioSelecionado);
    return !!funcionario && this.buscaFuncionario.trim() === this.rotuloFuncionario(funcionario);
  }

}
